<script setup lang="ts">
  import { useValidationSchemas } from '~/composables/useValidationSchemas'

  const model = defineModel<{
    newPassword: string
    confirmNewPassword: string
  }>({ required: true })

  const form = ref()

  const { t } = useI18n()
  const { passwordFieldsSchema } = useValidationSchemas()

  defineExpose({
    schema: passwordFieldsSchema,
    validate: () => form.value?.validate(),
  })
</script>

<template>
  <div class="flex w-full flex-col gap-2">
    <UForm ref="form" :state="model" :schema="passwordFieldsSchema" class="flex w-full flex-col gap-2"
      >
      <UFormField :label="t('forms.new-password-title')" name="newPassword">
        <InputPassword
          v-model="model.newPassword"
          :placeholder="t('forms.new-password')"
        />
      </UFormField>

      <UFormField
        :label="t('forms.confirm-password-title')"
        name="confirmNewPassword"
      >
        <InputPassword
          v-model="model.confirmNewPassword"
          :placeholder="t('forms.confirm-password')"
        /> </UFormField
    ></UForm>
  </div>
</template>
